export const reportsEn = {
  REPORTS: 'Reports',
  DOWNLOAD_REPORT: 'Download Report',
  RECEIVABLES_AGING: 'Receivables Aging',
  FEES: 'Fees',
  AVAILABLE_FOR_RELEASE: 'Available for Release',
  //BEGIN MICHAEL
  EMAIL_ALREADY_EXISTS_ON_LIST: 'Email already exists on the list',
  EMAILS_TO_SEND_REPORT: 'Emails to send report',
  EXPORT: 'Export',
  CLIENT_NAME: 'Client Name',
  TOTAL: 'Total',
  TOTAL_FEES: 'Total Fees',
  PAYMENT_AMOUNT: 'Payment Amount',
  CHARGEBACK: 'Chargeback',
  PAID_ON_DATE: 'Paid on Date',
  ERROR_GET_SETTLEMENT_REPORT: 'Error getting settlement report totals',
  FILTER_TYPE: 'Filter Type',
  AS_OF_DATE: 'As of Date',
  SETTLEMENT_REPORT: 'Settlement Report',
  SETTLEMENT_DATE_VIEW_RECORDS: 'To display results, choose a date range and select a filter type.',
  REPORTS_SENT_TO_EMAILS: 'Reports emails were sent successfully.',
  //END MICHAEL
  //BEGIN ESTEBAN
  AGED_0_TO_30: '0-30 Aged',
  AGED_31_TO_60: '31-60 Aged',
  AGED_61_TO_90: '61-90 Aged',
  AGED_91_TO_120: '91-120 Aged',
  AGED_120_PLUS: '120+ Aged',
  AGING_BY_DEBTOR_REPORT: 'Aging By Debtor Report',
  CLIENT_TOTALS: 'Client Totals',
  DEBTORS_PER_PAGE: 'Debtors per Page',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'If you do not see data, please select the end date up to which you wish to retrieve the information. This date is required to generate the corresponding reports.',
  //END ESTEBAN
}

export const reportsEs: typeof reportsEn = {
  REPORTS: 'Informes',
  DOWNLOAD_REPORT: 'Descargar Informe',
  RECEIVABLES_AGING: 'Receivables Aging',
  FEES: 'Fees',
  AVAILABLE_FOR_RELEASE: 'Available for Release',
  //BEGIN MICHAEL
  EMAIL_ALREADY_EXISTS_ON_LIST: 'El correo electrónico ya existe en la lista',
  EMAILS_TO_SEND_REPORT: 'Correos electrónicos para enviar informe',
  EXPORT: 'Exportar',
  CLIENT_NAME: 'Nombre del Cliente',
  TOTAL: 'Total',
  TOTAL_FEES: 'Total de Tarifas',
  PAYMENT_AMOUNT: 'Monto del Pago',
  CHARGEBACK: 'Reembolso',
  PAID_ON_DATE: 'Pagado en Fecha',
  ERROR_GET_SETTLEMENT_REPORT: 'Error al obtener los totales del informe de liquidación',
  FILTER_TYPE: 'Tipo de Filtro',
  AS_OF_DATE: 'A partir de la Fecha',
  SETTLEMENT_REPORT: 'Informe de Liquidación',
  SETTLEMENT_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas y seleccione un tipo de filtro.',
  REPORTS_SENT_TO_EMAILS: 'Los informes se enviaron correctamente a los correos electrónicos.',
  //END MICHAEL
  //BEGIN ESTEBAN
  AGED_0_TO_30: '0-30 Días',
  AGED_31_TO_60: '31-60 Días',
  AGED_61_TO_90: '61-90 Días',
  AGED_91_TO_120: '91-120 Días',
  AGED_120_PLUS: '120+ Días',
  AGING_BY_DEBTOR_REPORT: 'Informe de antigüedad por deudor',
  CLIENT_TOTALS: 'Totales del Cliente',
  DEBTORS_PER_PAGE: 'Deudores por Página',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'Si no ve datos, seleccione la fecha de finalización hasta la cual desea recuperar la información. Esta fecha es necesaria para generar los reportes correspondientes.',
  //END ESTEBAN
}
